import { CountViewParameters } from "components/player-page/player/models";
import { ZPlayNetworkService } from "commons";
import AuthenticationService from "./authentication-service";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export class ContentEnduserService {

    public static getContentListWithContent = (callback: any, errCallback: any) => {

        let apiUrl = (!AuthenticationService.getLocalCurrentUser() && process.env.REACT_APP_ALLOW_PUBLIC_CONTENT === "true") ?
            `${API_BASE_URL}/api/public/content-lists/with-contents` : `${API_BASE_URL}/api/content-lists/with-contents`;

        ZPlayNetworkService.get(apiUrl, callback, errCallback);
    };

    public static getContentById = (id: string, callback: any, errCallback: any) => {

        let apiUrl = (!AuthenticationService.getLocalCurrentUser() && process.env.REACT_APP_ALLOW_PUBLIC_CONTENT === "true") ?
            `${API_BASE_URL}/api/public/contents/${id}` : `${API_BASE_URL}/api/contents/${id}`;

        ZPlayNetworkService.get(apiUrl, callback, errCallback);
    };

    public static getMainContent = (callback: any, errCallback: any) => {

        let apiUrl = (!AuthenticationService.getLocalCurrentUser() && process.env.REACT_APP_ALLOW_PUBLIC_CONTENT === "true") ?
            `${API_BASE_URL}/api/public/contents/main` : `${API_BASE_URL}/api/contents/main`;

        ZPlayNetworkService.get(apiUrl, callback, errCallback);
    };

    public static getFilteredContentList = (request: any, callback: any, errCallback: any) => {

        let apiUrl = (!AuthenticationService.getLocalCurrentUser() && process.env.REACT_APP_ALLOW_PUBLIC_CONTENT === "true") ?
            `${API_BASE_URL}/api/public/contents/list` : `${API_BASE_URL}/api/contents/list`;

        let parametersArray: [any, any][] = [
            ["pageId", request.pageId],
            ["pageSize", request.pageSize],
            ["searchText", request.searchText],
        ];

        if (request.contentList)
            parametersArray.push(["contentList", request.contentList]);

        ZPlayNetworkService.get(apiUrl, callback, errCallback, parametersArray);
    };

    public static getStartedOrStartingLiveContents = (callback: any, errCallback: any) => {

        let apiUrl = (!AuthenticationService.getLocalCurrentUser() && process.env.REACT_APP_ALLOW_PUBLIC_CONTENT === "true") ?
            `${API_BASE_URL}/api/public/contents/live-now-or-starting` : `${API_BASE_URL}/api/contents/live-now-or-starting`;

        ZPlayNetworkService.get(apiUrl, callback, errCallback);
    };

    public static likeContent = (id: string, callback: any, errCallback: any) => {

        ZPlayNetworkService.put(`${API_BASE_URL}/api/contents/${id}/like`, {}, callback, errCallback);
    };

    public static setContentFavorite = (id: string, callback: any, errCallback: any) => {

        ZPlayNetworkService.put(`${API_BASE_URL}/api/contents/${id}/favorite`, {}, callback, errCallback);
    };

    public static buyContent = (id: string, callback: any, errCallback: any) => {

        ZPlayNetworkService.put(`${API_BASE_URL}/api/contents/${id}/buy`, {}, callback, errCallback);
    };

    public static countView = (id: string, countViewInformations: CountViewParameters) => {

        let apiUrl = (!AuthenticationService.getLocalCurrentUser() && process.env.REACT_APP_ALLOW_PUBLIC_CONTENT === "true") ?
            `${API_BASE_URL}/api/public/contents/${id}/count-view` : `${API_BASE_URL}/api/contents/${id}/count-view`;

        ZPlayNetworkService.put(apiUrl, countViewInformations, () => { }, () => { });
    };

}
